import { getUnixTimestampDate } from "../../../packages/date/dateFunctions.js";
import { AmbrightDate } from "./AmbrightDate.js";

const FIRST_SPRINT_MONDAY = "2026-01-05T12:00:00Z";
const PERIOD_7_DAYS = 7 * 24 * 60 * 60 * 1000;

/**
 * Generates Ambright sprint dates.
 */
export const generateSprintDates = () => {
  const dates: AmbrightDate[] = [];

  for (let nthMonday = 0; nthMonday < 104; nthMonday++) {
    const date = new Date(FIRST_SPRINT_MONDAY);
    date.setTime(date.getTime() + nthMonday * PERIOD_7_DAYS);

    const remainder = nthMonday % 4;
    const isSprint = remainder === 0 || remainder === 1;

    dates.push({
      date: getUnixTimestampDate(Math.round(date.getTime() / 1000)),
      sprint: isSprint ? "ON" : "OFF"
    });
  }

  return dates;
};
